import EvaluatorOverview from "./EvaluatorOverview";

export default function Review() {
  return (
    <EvaluatorOverview headerTranslation="global.menu.evaluation.review" reviewerView={true} />
  );
}
